import { Input } from 'cd-eft/components/common/Input';
import { observer } from 'mobx-react';
import React, { Fragment, useEffect, useRef } from 'react';
import { FormulaBanner } from '../Common/FormulaBanner';
import { InputContainer, ResultsContainer, DescriptionContainer, ImageContainer, FormulaPrintModalContainer } from '../template/FormulaFormTemplates';
import { HoodedInletVM } from './HoodedInletVM';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import pdfLogo from 'cd-eft/assets/images/pdf-blue.svg';
import { StageDischargeGraph } from '../Common/StageDischargeGraph';



const HoodedInletComponent = (props) => {
  const vm = useRef(new HoodedInletVM(props)).current;
  useEffect(() => {
    vm.getFormData(`${props.section}_${props.title}_${props.id}`);
  }, []);

  return (
    <Fragment>
      <FormulaBanner title={vm.formulaTitle} help={vm.bannerHelpLink} />

      <div className="row formula-content">
        <InputContainer
          computeCallback={() => {
            vm.computeHoodInlet();
          }}
          printCallback={() => vm.launchAndExport()}
          disableCompute={vm.disableComputeBtn}
          isLoading={vm.isLoading}
          disablePrint={!vm.hasResults || vm.disablePrintBtn}
        >
          <span className="input-help-header">
            <a href={vm.helpLink} target='_blank'>Help select n value <img src={pdfLogo} alt={'PDF logo'} /></a>
          </span>
          <h2 className="sections-heading">Earthworks</h2>
          <Input
            label="Top Width (ft)"
            idAndName="top-width"
            valid={!vm.formValidation.topWidth}
            value={vm.hoodInletFormData.earthWorksDto.topWidth}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            min={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            className={vm.hoodInletErrorClass('topWidth')}
          />
          <Input
            label="Side Slopes Up-stream (ft/ft)"
            idAndName="up-stream"
            valid={!vm.formValidation.upStream}
            value={vm.hoodInletFormData.commonSideSlopeDto.upStream}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            min={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            className={vm.hoodInletErrorClass('upStream')}
          />
          <Input
            label="Side Slopes Down-stream (ft/ft)"
            idAndName="do-stream"
            valid={!vm.formValidation.downStream}
            value={vm.hoodInletFormData.commonSideSlopeDto.downStream}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            min={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            className={vm.hoodInletErrorClass('downStream')}
          />
          <h2 className="sections-heading">Pipe</h2>
          <Input
            label="Manning's n"
            idAndName="manning-n"
            valid={!vm.formValidation.manningsN}
            value={vm.hoodInletFormData.commonPipeDto.manningsN}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.0001}
            min={0.0001}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            className={vm.hoodInletErrorClass('manningsN')}
          />
          <Input
            label="Pipe Diameter (in)"
            idAndName="pipe-diameter"
            valid={!vm.formValidation.pipeDiameter}
            value={vm.hoodInletFormData.commonPipeDto.pipeDiameter}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            min={0.02}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            className={vm.hoodInletErrorClass('pipeDiameter')}
          />
          <Input
            label="Extra Pipe Beyond Toe (ft)"
            idAndName="extra-pipe-b-toe"
            valid={!vm.formValidation.extraPipeBeyondToe}
            value={vm.hoodInletFormData.commonPipeDto.extraPipeBeyondToe}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            min={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            className={vm.hoodInletErrorClass('extraPipeBeyondToe')}
          />
          <Input
            label="Skew Angle°"
            idAndName="skew-angle"
            valid={!vm.formValidation.skewAngle}
            value={vm.hoodInletFormData.commonPipeDto.skewAngle}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            min={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            className={vm.hoodInletErrorClass('skewAngle')}
          />
          <h2 className="sections-heading">Elevations</h2>
          <Input
            label="Top Elevation (ft)"
            idAndName="top-elevation"
            valid={!vm.formValidation.topElev}
            value={vm.hoodInletFormData.hoodedInletElevationDto.topElev}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            min={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            className={vm.hoodInletErrorClass('topElev')}
          />
          <Input
            label="Auxiliary Spillway Elevation (ft)"
            idAndName="aux-spillway-Elevation"
            valid={!vm.formValidation.auxSpillwayElev}
            value={vm.hoodInletFormData.hoodedInletElevationDto.auxSpillwayElev}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            min={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            className={vm.hoodInletErrorClass('auxSpillwayElev')}
          />
          <Input
            label="Water Elevation (ft)"
            idAndName="water-elevation"
            valid={!vm.formValidation.waterElev}
            value={vm.hoodInletFormData.hoodedInletElevationDto.waterElev}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            min={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            className={vm.hoodInletErrorClass('waterElev')}
          />
          <Input
            label="Toe Elevation (ft)"
            idAndName="toe-elevation"
            valid={!vm.formValidation.toeElev}
            value={vm.hoodInletFormData.hoodedInletElevationDto.toeElev}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            min={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            className={vm.hoodInletErrorClass('toeElev')}
          />
          <Input
            label="Inlet Elevation (ft)"
            idAndName="inlet-elevation"
            valid={!vm.formValidation.inletElev}
            value={vm.hoodInletFormData.hoodedInletElevationDto.inletElev}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            min={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            className={vm.hoodInletErrorClass('inletElev')}
          />
          <Input
            label="Outlet Elevation (ft)"
            idAndName="outlet-elevation"
            valid={!vm.formValidation.outletElev}
            value={vm.hoodInletFormData.hoodedInletElevationDto.outletElev}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            min={0.01}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            className={vm.hoodInletErrorClass('outletElev')}
          />
          <div className='checkbox-container'>
            <label className='label-formula-checkbox usa-label' htmlFor="enable-trailwater-elev">
              Enable Tailwater
            </label>
            <input
              className="checkbox-input-formulas"
              id="enable-trailwater-elev"
              data-testid="the-Checkbox"
              type="checkbox"
              name="enable-trailwater-elev"
              checked={vm.hoodInletFormData.hoodedInletElevationDto.enableTailWater}
              onChange={(e) => {
                vm.toggleEnableTailwaterElevation()
              }}
              onBlur={(e) => vm.validateInput('tailwater-elevation', vm.hoodInletFormData.hoodedInletElevationDto.tailwaterElev)}
            />
          </div>
          <Input
            label="Tailwater Elevation (ft)"
            idAndName="tailwater-elevation"
            valid={!vm.formValidation.tailwaterElev}
            value={vm.hoodInletFormData.hoodedInletElevationDto.tailwaterElev}
            type="number"
            onChange={(e) => {
              vm.handleInputChange(e);
            }}
            step={0.01}
            min={0.01}
            disabled={!vm.hoodInletFormData.hoodedInletElevationDto.enableTailWater}
            onBlur={(e) => vm.validateInput(e.target.name, e.target.value)}
            onKeyDown={vm.handleOnKeyDown}
            className={vm.hoodInletErrorClass('tailwaterElev')}
          />
        </InputContainer>
        <div className="col formula-information">
          {vm.hasResults ? (
            <Fragment>
              <div className="row formula-results">
                <ResultsContainer>
                  <div className="col result-value-group">
                    <div className="row">
                      <div className="col-auto result-label">
                        Capacity (cfs):
                      </div>
                      <div className="col-auto result-value">{vm.hoodInletFormResults.capacity}</div>
                    </div>
                    <div className="row">
                      <div className="col-auto result-label">
                        Length of Pipe (ft):
                      </div>
                      <div className="col-auto result-value">{vm.hoodInletFormResults.pipeLength}</div>
                    </div>
                    <div className="row">
                      <div className="col-auto result-label">
                        Seepage Path (ft):
                      </div>
                      <div className="col-auto result-value">{vm.hoodInletFormResults.seepagePath}</div>
                    </div>
                  </div>
                </ResultsContainer>
              </div>
              {vm.plotData ? <StageDischargeGraph targetDivId={vm.targetDivID} plotData={vm.plotData} windowOptions={vm.windowOptions} forReport={false} /> : null}
            </Fragment>
          ) : null}
          <div className="row formula-description">
            <DescriptionContainer>
              <p>
                {vm.formDescription}
                &nbsp;
                <a target="_blank" href={vm.bannerHelpLink}>
                  Learn More
                  <img src={pdfLogo} alt={'PDF logo'} />
                </a>
              </p>
            </DescriptionContainer>
          </div>
          <div className="row formula-images">
            <ImageContainer>
              <img className="Hooded-Inlet-img" src={vm.image} alt={vm.hydraulicFormulaImageDescription} title={vm.formulaTitle} />
            </ImageContainer>
          </div>
        </div>
        {vm.isLoading && <Loader message={''} />}
      </div>
      <FormulaPrintModalContainer
        vm={vm}
        inputs={vm.exportedInputs}
        results={vm.exportedResults}
        images={[vm.image]}
        formulaName={vm.formulaTitle}
        windowOptions={vm.windowOptionsForPrint}
        stageDischarge={vm.plotData !== undefined ? true : false}// Should be true for this formula. plotData should be propulated in correct format after api results
        stageDischargeData={vm.plotData}
      />
    </Fragment>
  );
};

export const HoodedInletFormula = observer(HoodedInletComponent);
